import { render, staticRenderFns } from "./CreateCreatorAccountForm.vue?vue&type=template&id=f4fb6a20"
import script from "./CreateCreatorAccountForm.vue?vue&type=script&lang=js"
export * from "./CreateCreatorAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports